
import store from "../store"
import {ResourceManagerTask} from "@k/global/resourcemanager/task";
import {logIfDebug} from "@k/global/logFunctions";
export const taskrunner = {
    taskExists: function (taskname) {
        return store.getters.taskExists(taskname)
    },
    addOrExecuteTask: function (task: ResourceManagerTask) {
        if (store.getters.taskExists(task.taskName)) {
            logIfDebug("deleting old Task with same name " + task.taskName);
            store.commit("deleteTask", task.taskName);
        }

        if (store.getters.taskPrerequisitesMet(task)) {
            task.execute(store.getters.getDataForTask(task));
            return;
        } else {
            store.commit("addTask", task);
        }
    },
    checkTasksAndExecute(): void {
        store.dispatch("checkTasksAndExecute");
    },
    createTask(taskName: string) {
        return new ResourceManagerTask({taskName: taskName});
    },
    executeInvalidation(eventName: string) {
        store.dispatch("deleteInvalidatedTasks", eventName);
    },
}
